import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', background: '#222', color: '#fff', minHeight: '100vh' }}>
          <h2>Algo salió mal.</h2>
          <button 
            style={{ padding: '10px 20px', background: '#00e5ff', color: '#000', border: 'none', borderRadius: '5px', cursor: 'pointer', marginBottom: '20px', fontWeight: 'bold' }}
            onClick={() => {
              if (window.caches) {
                window.caches.keys().then((names) => {
                  for (let name of names) window.caches.delete(name);
                });
              }
              window.location.href = window.location.pathname + '?v=' + new Date().getTime() + window.location.hash;
            }}
          >
            VACIAR CACHÉ Y RECARGAR
          </button>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
